<template>
  <div v-loading="loading" class="sites-large-screen-comp">
    <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="120px">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="所选网点" prop="sites">
            <el-select
              style="width: 100%;"
              multiple
              :disabled="true"
              v-model="form.sites"
              placeholder="请选择 所选网点"
            >
              <el-option
                v-for="item in sitesList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="大屏地址" prop="screenUrl">
            <el-select
              style="width: 100%;"
              v-model="form.screenUrl"
              placeholder="请选择 大屏地址"
            >
              <el-option
                v-for="item in screenUrlList"
                :key="item.id"
                :label="item.largeScreenAddress"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>        
        <el-col :span="24">
          <el-form-item label="大屏名称" prop="screenName">
            <el-select
              style="width: 100%;"
              v-model="form.screenName"
              placeholder="请选择 大屏名称"
            >
              <el-option
                v-for="item in screenNameList"
                :key="item.id"
                :label="item.largeScreenName"
                :value="item.largeScreenName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="text-align: right;">
      <el-button type="primary" @click="goToLink" size="small">
        跳转
      </el-button>
      <el-button icon="el-icon-circle-close" @click="onCancel" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import { nursingSave } from '../api/nursingManage.js';
import { getDictionary } from '@/api/common.js';
export default {
  components: {},
  props: {
    rowData: {
      default: [],
    },
    projectId: {},
  },
  data() {
    return {
      sitesList: [],
      screenUrlList: [],
      screenNameList: [],
      form: {
        sites: '',
        screenUrl: '',
        screenName: '',
      },      
      formRules: {
        screenUrl: [{ required: true, message: '请选择大屏地址', trigger: 'change' }],
        screenName: [{ required: true, message: '请选择大屏名称', trigger: 'change' }],        
      },      
    };
  },
  computed: {
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    onCancel() {
      this.$emit('close');
    },
    initData() {
      console.log('rowData---', this.rowData);
      const arr = [];
      const arr1 = [];
      const arr2 = [];
      const addrLst = [];
      const nameLst = [];
      if (this.rowData.length) {
        this.rowData.forEach((item) => {
          const { id, name, largeScreenName, largeScreenAddress } = item;
          arr.push({ id, name });
          if (largeScreenAddress && !addrLst.includes(largeScreenAddress)) {
            arr1.push({ id, largeScreenAddress });
            addrLst.push(largeScreenAddress)
          }
          if (largeScreenName && !nameLst.includes(largeScreenName)) {
            arr2.push({ id, largeScreenName });
            nameLst.push(largeScreenName)
          }
        })
      }
      this.sitesList = arr;
      this.screenUrlList = arr1;
      this.screenNameList = arr2;      
      console.log('this.screenNameList---', this.screenNameList);
      console.log('this.screenUrlList---', this.screenUrlList);
      this.form.sites = this.sitesList.map(item => item.id);
      this.form.screenUrl = (this.screenUrlList[0] && this.screenUrlList[0].id) || '';
      this.form.screenName = (this.screenNameList[0] && this.screenNameList[0].largeScreenName) || '';
    },
    getScreenUrlVal() {
      let val = '';
      console.log('this.form.screenUrl--1-', this.form.screenUrl);
      if (this.form.screenUrl) {
        const sel = this.screenUrlList.find(item => item.id == this.form.screenUrl);
        val = sel ? sel.largeScreenAddress : '';
      }
      return val;
    },
    // 重组链接
    getUrl() {
      let url = '';
      let ids = this.form.sites;
      ids = ids.join(',');   
      console.log('ids----', ids);      
      let screenUrl = this.getScreenUrlVal();
      console.log('this.screenUrl----', screenUrl);
      if (screenUrl) {
        url = `${screenUrl}&nursinghomeId=${ids}`;
        console.log('url----', url);
        if (this.form.screenName) {
          url += `&name=${this.form.screenName}`;
        }
      }      
      return url;
    },
    goToLink() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          console.log('rowData---');
          const url = this.getUrl()
          if (url) {
            window.open(url, '_blank');
            // window.location.href = url;
            this.$emit('close'); 
          } else {
            this.$message.error('大屏地址不正确');
            return                 
          }
        }
      });
    },
  },
};
</script>
<style scoped>
</style>
